import React from "react";
import { Form, Col, Row } from "react-bootstrap";

interface CheckboxGroupProps {
  checkboxes: { id: string; label: string; checked: boolean }[];
  onCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({
  checkboxes,
  onCheckboxChange,
}) => {
  return (
    <Row className="checkbox-row">
      {checkboxes.map((checkbox) => (
        <Col xs={12} md="auto" key={checkbox.id} className="checkbox-col mb-2">
          <Form.Check
            type="checkbox"
            id={checkbox.id}
            label={checkbox.label}
            checked={checkbox.checked}
            onChange={onCheckboxChange}
            className="small"
          />
        </Col>
      ))}
    </Row>
  );
};

export default CheckboxGroup;
